{
  "cms.article.action.publish": "Julkaise tuotantoon",
  "cms.article.action.retry": "Yritä uudelleen",
  "cms.article.action.saveDraft": "Tallenna luonnos",
  "cms.article.accordion.add": "Lisää haitari",
  "cms.article.blocks.addText": "Lisää vapaa teksti",
  "cms.article.blocks.empty": "Ei sisältöä",
  "cms.article.blocks.heading": "Sisältö",
  "cms.article.blocks.removeText": "Poista vapaa teksti",
  "cms.article.blocks.textLabel": "Vapaa teksti",
  "cms.article.blocks.summaryFilled": "(sisältöä)",
  "cms.article.blocks.summaryEmpty": "(tyhjä)",
  "cms.article.blocks.done": "OK",
  "cms.article.accordion.itemTitle": "Haitari",
  "cms.article.accordion.noTitle": "(ei otsikkoa)",
  "cms.article.accordion.remove": "Poista haitari",
  "cms.article.field.accordion": "Haitarivalikko (valinnainen)",
  "cms.article.field.accordion.bodyHtml": "Sisältö (HTML)",
  "cms.article.field.accordion.title": "Otsikko",
  "cms.article.field.bodyHtml": "Vapaa teksti (HTML)",
  "cms.article.field.heroImage": "Kuva",
  "cms.article.field.slug": "URL-tunnus (slug)",
  "cms.article.field.slug.lockedHelp": "Slug on lukittu julkaisun jälkeen ja säilyttää linkkien pysyvyyden.",
  "cms.article.field.title": "Otsikko",
  "cms.article.error.heroImageHttps": "Kuva-URL:n on alettava https:// tai oltava sama-alkuperäinen polku (/media/...).",
  "cms.article.error.slugFormat": "Slugin on sisällettävä vain pieniä kirjaimia, numeroita ja väliviivoja (a–z, 0–9, -).",
  "cms.article.error.titleRequired": "Otsikko on pakollinen.",
  "cms.article.error.titleNotDerivable": "Otsikossa on oltava vähintään yksi latinalainen kirjain tai numero.",
  "cms.article.publishContract.body": "Luonnos näkyy vain esikatselussa. Julkaisu siirtää muutokset tuotantoon ja tallentaa version.",
  "cms.article.linkedCard.title": "Etusivun kortti",
  "cms.article.linkedCard.tabLabel": "Näkyy välilehdellä",
  "cms.article.linkedCard.tab.none": "Ei korttia",
  "cms.article.linkedCard.tab.lakikaveri": "Lakikaveri",
  "cms.article.linkedCard.tab.palvelut": "Jäsenyys ja edut",
  "cms.article.linkedCard.help": "Kortti näytetään etusivulla valitulla välilehdellä ja linkittää tähän palvelusivuun.",
  "cms.article.linkedCard.creating": "Luodaan etusivun korttia…",
  "cms.article.linkedCard.unitMemberDissociationBlocked": "Kortti ja sivu muodostavat julkaisukokonaisuuden, eikä korttia voi vielä irrottaa erikseen. Arkistoi koko kokonaisuus sisältöluettelosta.",
  "cms.article.linkedCard.createError": "Kortin luonti epäonnistui. Yritä uudelleen valitsemalla välilehti.",
  "cms.article.linkedCard.createBlockedInvalidSlug": "Tallenna palvelusivu ensin kelvollisella URL-tunnisteella, ennen kuin lisäät kortin.",
  "cms.article.linkedCard.error.partialSave": "Palvelusivu tallennettu, mutta kortin tallennus epäonnistui. Yritä uudelleen."
}
